module.exports = __webpack_public_path__ + "../resources/img/ic_cancel_light.7e15da0f.svg";